import { createContext } from "react";
import { GetReportSettingsResponse } from "../api/dtos";

const ReportSettingsContext = createContext<GetReportSettingsResponse>(new GetReportSettingsResponse())

export default ReportSettingsContext;